module.exports = __webpack_public_path__ + "img/full0-min.12c45c47.png";